module.exports = __webpack_public_path__ + "img/boxed_meals_4.2cab9c91.jpg";